<template>
  <tr class="filter-row">
    <td
      v-if="showSelect"
      :key="'showSelect'"
    />
    <template v-for="(fo, key) in rows">
      <td
        v-if="fo !== null && !fo.onlyBox"
        :key="key"
      >
        <v-text-field
          v-if="fo.type === 'range'"
          v-model="options[key].filter.from"
          dense
          single-line
          :label="fo.label"
          @keypress.enter="() => {
            if(options[key].filter.from)
              setFilters({...filter, [key]: { from: options[key].filter.from, to: options[key].filter.from}})
            else
              removeFilter(key)
          }"
          @blur="() => {
            if(options[key].filter.from)
              setFilters({...filter, [key]: { from: options[key].filter.from, to: options[key].filter.from}})
            else
              removeFilter(key)
          }"
        />
        <v-text-field
          v-else-if="fo.type === 'free'"
          v-model="options[key].filter"
          dense
          single-line
          :label="fo.label"
          @keypress.enter="{
            if(options[key].filter)
              setFilters({...filter, [key]: options[key].filter})
            else
              removeFilter(key)
          }"
          @blur="() => {
            if(options[key].filter)
              setFilters({...filter, [key]: options[key].filter})
            else
              removeFilter(key)
          }"
        />
        <v-select
          v-else-if="fo.type === 'multi' && fo.options && fo.options.length"
          v-model="options[key].filter"
          dense
          single-line
          item-text="label"
          item-value="slug"
          multiple
          :items="fo.options"
          :label="fo.label"
          @keypress.enter="{
            if(options[key].filter)
              setFilters({...filter, [key]: options[key].filter})
            else
              removeFilter(key)
          }"
          @blur="() => {
            if(options[key].filter)
              setFilters({...filter, [key]: options[key].filter})
            else
              removeFilter(key)
          }"
        />
        <v-select
          v-else-if="fo.type === 'single' && fo.options && fo.options.length"
          v-model="options[key].filter"
          dense
          single-line
          item-text="label"
          item-value="slug"
          :items="[...fo.options, {slug: null, label: $t('all')}]"
          :label="fo.label"
          @keypress.enter="{
            if(options[key].filter)
              setFilters({...filter, [key]: options[key].filter})
            else
              removeFilter(key)
          }"
          @blur="() => {
            if(options[key].filter)
              setFilters({...filter, [key]: options[key].filter})
            else
              removeFilter(key)
          }"
        />
        <v-menu
          v-else-if="fo.type === 'date-range'"
          v-model="menus[key]"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="options[key].filter.from"
              :label="fo.label"
              prepend-icon="event"
              readonly
              dense
              v-on="on"
            />
          </template>
          <v-date-picker
            :value="options[key].filter.from"
            first-day-of-week="1"
            @input="val => {setDateFilter(val, key)}"
          >
            <v-spacer />
            <v-btn
              text
              color="primary"
              @click="() => {
                removeFilter(key)
                menus[key] = false;
              }"
            >
              {{ $t('clear') }}
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="() => {
                setFilters({...filter, [key]: options[key].filter})
                menus[key] = false
              }"
            >
              {{ $t('ok') }}
            </v-btn>
          </v-date-picker>
        </v-menu>
      </td>
      <td
        v-else
        :key="key"
        colspan="1"
      />
    </template>
  </tr>
</template>

<script>
  export default {
    props: {
      showSelect: {
        type: Boolean,
        default: false,
      },
      filter: {
        type: Object,
        default () {
          return {}
        },
      },
      filterOptions: {
        type: Object,
        default () {
          return {}
        },
      },
      headers: {
        type: Array,
        default () {
          return []
        },
      },
    },
    data () {
      return {
        selectedOption: null,
        activeFilters: {},
        options: {},
        menus: {},
      }
    },
    computed: {
      rows: function () {
        const filterKeys = Object.keys(this.options)
        const rows = {}
        this.$_.each(this.headers, h => {
          if (!this.$_.includes(filterKeys, h.value)) rows[h.value] = null
          else { rows[h.value] = this.options[h.value] }
        })

        return rows
      },
    },
    mounted: function () {
      this.options = this.filterOptions
      this.activeFilters = this.filter

      this.$_.each(this.filter, (i, key) => {
        this.options[key].filter = i
      })
    },
    methods: {
      setFilters: function (filters) {
        this.activeFilters = filters
        this.$emit('set-filter', filters)
      },
      removeFilter: function (key) {
        const f = { ...this.filter }
        delete f[key]
        this.activeFilters = f
        this.$emit('set-filter', f)
      },
      setDateFilter: function (val, key) {
        this.options[key].filter = {
          from: val,
          to: this.$moment(val, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD'),
        }
      },
    },
  }
</script>

<style scoped>
tr.filterRow td {
    padding-top: 10px;
}
</style>
